export const TeamData = {
  members: [
    {
      key: "1",
      name: "Rasansha Luthra",
      position: "Chairperson ACM",
      linkedInURL: "https://in.linkedin.com/in/rasansha-luthra-475153170",
      githubURL: "https://github.com/Rasu11",
      twitterURL: "https://twitter.com/LuthraRasansha",
      displayPicSrc: require("../assets/display-pics/rasansha.jpg")
    },
    {
      key: "2",
      name: "Vedant Kaushish",
      position: "Vice Chairperson ACM",
      linkedInURL: "https://in.linkedin.com/in/vedant-kaushish-974036181",
      githubURL: "https://github.com/whitewolf4237",
      twitterURL: "",
      displayPicSrc: require("../assets/display-pics/vedant.jpg")
    },
    {
      key: "3",
      name: "Nitesh Singh",
      position: "Vice Chairperson ACM",
      linkedInURL: "https://in.linkedin.com/in/nitesh-singh-241024181",
      githubURL: "https://github.com/nitessh-singh",
      twitterURL: "https://twitter.com/niteshlumos",
      displayPicSrc: require("../assets/display-pics/nitesh.jpg")
    },
    {
      key: "4",
      name: "Daksh Khetan",
      position: "Web Master ACM",
      linkedInURL: "https://www.linkedin.com/in/dakshkhetan",
      githubURL: "https://github.com/dakshkhetan",
      twitterURL: "https://twitter.com/dakshkhetan",
      displayPicSrc: require("../assets/display-pics/daksh.jpg")
    },
    {
      key: "5",
      name: "Aryan Joshi",
      position: "General Secretary ACM",
      linkedInURL: "https://in.linkedin.com/in/aryan-joshi-7b1766145",
      githubURL: "https://github.com/WHITEWOLF619",
      twitterURL: "",
      displayPicSrc: require("../assets/display-pics/aryan.jpg")
    },
    {
      key: "6",
      name: "Udit Sisodia",
      position: "Treasurer ACM",
      linkedInURL: "https://www.linkedin.com/in/udit-sisodia-6b5799190",
      githubURL: "https://github.com/udit360",
      twitterURL: "https://twitter.com/SisodiaUdit",
      displayPicSrc: require("../assets/display-pics/udit.jpg")
    },
    {
      key: "7",
      name: "Ankur Sharma",
      position: "Membership Chairperson ACM",
      linkedInURL: "https://www.linkedin.com/in/ankur2825",
      githubURL: "https://github.com/ankur2825",
      twitterURL: "https://twitter.com/arkhamsamurai",
      displayPicSrc: require("../assets/display-pics/ankur.jpg")
    },
    {
      key: "8",
      name: "Bhumika Manocha",
      position: "Chairperson ACM-W",
      linkedInURL: "https://www.linkedin.com/in/bhumika-manocha-762128168",
      githubURL: "https://github.com/BhumikaManocha",
      twitterURL: "https://twitter.com/BhumikaManocha",
      displayPicSrc: require("../assets/display-pics/bhumika.jpg")
    },
    {
      key: "9",
      name: "Charu Goyal",
      position: "Vice Chairperson ACM-W",
      linkedInURL: "https://www.linkedin.com/in/charu-goyal-12738816a",
      githubURL: "https://github.com/Charugoyal3",
      twitterURL: "https://twitter.com/CharuGoyal17",
      displayPicSrc: require("../assets/display-pics/charu.jpg")
    },
    {
      key: "10",
      name: "Navika Chhauda",
      position: "Vice Chairperson ACM-W",
      linkedInURL: "https://in.linkedin.com/in/navikachhauda",
      githubURL: "",
      twitterURL: "",
      displayPicSrc: require("../assets/display-pics/navika.jpg")
    },
    {
      key: "11",
      name: "Arushi Gupta",
      position: "Web Master ACM-W",
      linkedInURL: "https://in.linkedin.com/in/arushi-gupta-050976181",
      githubURL: "https://github.com/arushigupta07",
      twitterURL: "https://twitter.com/ArushiG02608584",
      displayPicSrc: require("../assets/display-pics/arushi.jpg")
    },
    {
      key: "12",
      name: "Bhavini Priyamvada",
      position: "Membership Chairperson ACM-W",
      linkedInURL: "https://in.linkedin.com/in/bhavini-priyamvada-9497931a5",
      githubURL: "",
      twitterURL: "",
      displayPicSrc: require("../assets/display-pics/bhavini.jpg")
    }
  ],
  mentors: [
    {
      key: "13",
      name: "Prof. Vanita Jain",
      displayPicSrc: require("../assets/display-pics/vanitajain.jpg")
    },
    {
      key: "14",
      name: "Prof. Sarita Yadav",
      displayPicSrc: require("../assets/display-pics/saritayadav.jpg")
    },
    {
      key: "15",
      name: "Akanshu Raj",
      displayPicSrc: require("../assets/display-pics/akanshu.jpg")
    }
  ]
};
